"use strict";

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var idlUtils = require("../generated/utils");

var _require = require("../helpers/traversal"),
    closest = _require.closest;

var _require2 = require("../helpers/form-controls"),
    isDisabled = _require2.isDisabled,
    isSubmittable = _require2.isSubmittable,
    isButton = _require2.isButton;

var Blob = require("../generated/Blob.js");

var File = require("../generated/File.js");

var conversions = require("webidl-conversions");

exports.implementation = /*#__PURE__*/function (_Symbol$iterator) {
  function FormDataImpl(globalObject, args) {
    _classCallCheck(this, FormDataImpl);

    this._globalObject = globalObject;
    this._entries = [];

    if (args[0] !== undefined) {
      this._entries = constructTheEntryList(args[0]);
    }
  }

  _createClass(FormDataImpl, [{
    key: "append",
    value: function append(name, value, filename) {
      var entry = createAnEntry(name, value, filename);

      this._entries.push(entry);
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      this._entries = this._entries.filter(function (entry) {
        return entry.name !== name;
      });
    }
  }, {
    key: "get",
    value: function get(name) {
      var foundEntry = this._entries.find(function (entry) {
        return entry.name === name;
      });

      return foundEntry !== undefined ? idlUtils.tryWrapperForImpl(foundEntry.value) : null;
    }
  }, {
    key: "getAll",
    value: function getAll(name) {
      return this._entries.filter(function (entry) {
        return entry.name === name;
      }).map(function (entry) {
        return idlUtils.tryWrapperForImpl(entry.value);
      });
    }
  }, {
    key: "has",
    value: function has(name) {
      return this._entries.findIndex(function (entry) {
        return entry.name === name;
      }) !== -1;
    }
  }, {
    key: "set",
    value: function set(name, value, filename) {
      var entry = createAnEntry(name, value, filename);

      var foundIndex = this._entries.findIndex(function (e) {
        return e.name === name;
      });

      if (foundIndex !== -1) {
        this._entries[foundIndex] = entry;
        this._entries = this._entries.filter(function (e, i) {
          return e.name !== name || i === foundIndex;
        });
      } else {
        this._entries.push(entry);
      }
    }
  }, {
    key: _Symbol$iterator,
    value: /*#__PURE__*/_regeneratorRuntime.mark(function value() {
      var _iterator, _step, entry;

      return _regeneratorRuntime.wrap(function value$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _iterator = _createForOfIteratorHelper(this._entries);
              _context.prev = 1;

              _iterator.s();

            case 3:
              if ((_step = _iterator.n()).done) {
                _context.next = 9;
                break;
              }

              entry = _step.value;
              _context.next = 7;
              return [entry.name, idlUtils.tryWrapperForImpl(entry.value)];

            case 7:
              _context.next = 3;
              break;

            case 9:
              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);

              _iterator.e(_context.t0);

            case 14:
              _context.prev = 14;

              _iterator.f();

              return _context.finish(14);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, value, this, [[1, 11, 14, 17]]);
    })
  }]);

  return FormDataImpl;
}(Symbol.iterator);

function createAnEntry(name, value, filename) {
  var entry = {
    name: name
  }; // https://github.com/whatwg/xhr/issues/75

  if (Blob.isImpl(value) && !File.isImpl(value)) {
    var oldValue = value;
    value = File.createImpl(value._globalObject, [[], "blob", {
      type: oldValue.type
    }]); // "representing the same bytes"

    value._buffer = oldValue._buffer;
  }

  if (File.isImpl(value) && filename !== undefined) {
    var _oldValue = value;
    value = File.createImpl(value._globalObject, [[], filename, // spec makes no mention of `lastModified`; assume it is inherited
    // (Chrome's behavior)
    {
      type: _oldValue.type,
      lastModified: _oldValue.lastModified
    }]); // "representing the same bytes"

    value._buffer = _oldValue._buffer;
  }

  entry.value = value;
  return entry;
}

function constructTheEntryList(form, submitter) {
  // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#constructing-the-form-data-set
  // TODO: handle encoding
  // TODO: handling "constructing entry list"
  var controls = form.elements.filter(isSubmittable); // submittable is a subset of listed

  var entryList = [];

  var _iterator2 = _createForOfIteratorHelper(controls),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var field = _step2.value;

      if (closest(field, "datalist") !== null) {
        continue;
      }

      if (isDisabled(field)) {
        continue;
      }

      if (isButton(field) && field !== submitter) {
        continue;
      }

      if (field.type === "checkbox" && field._checkedness === false) {
        continue;
      }

      if (field.type === "radio" && field._checkedness === false) {
        continue;
      }

      if (field.localName === "object") {
        // in jsdom, no objects are "using a plugin"
        continue;
      } // TODO: Handle <input type="image">
      // TODO: handle form-associated custom elements.


      var name = field.getAttributeNS(null, "name");

      if (name === null || name === "") {
        continue;
      }

      if (field.localName === "select") {
        var _iterator3 = _createForOfIteratorHelper(field.options),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var option = _step3.value;

            if (option._selectedness === true && !isDisabled(field)) {
              appendAnEntry(entryList, name, option._getValue());
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      } else if (field.localName === "input" && (field.type === "checkbox" || field.type === "radio")) {
        var _value = field.hasAttributeNS(null, "value") ? field.getAttributeNS(null, "value") : "on";

        appendAnEntry(entryList, name, _value);
      } else if (field.type === "file") {
        if (field.files.length === 0) {
          var _value2 = File.createImpl(form._globalObject, [[], "", {
            type: "application/octet-stream"
          }]);

          appendAnEntry(entryList, name, _value2);
        } else {
          for (var i = 0; i < field.files.length; ++i) {
            appendAnEntry(entryList, name, field.files.item(i));
          }
        }
      } else {
        appendAnEntry(entryList, name, field._getValue());
      }

      var dirname = field.getAttributeNS(null, "dirname");

      if (dirname !== null && dirname !== "") {
        var dir = "ltr"; // jsdom does not (yet?) implement actual directionality

        appendAnEntry(entryList, dirname, dir);
      }
    } // TODO: formdata event

  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return entryList;
}

function appendAnEntry(entryList, name, value) {
  name = conversions.USVString(name);

  if (!File.isImpl(value)) {
    value = conversions.USVString(value);
  }

  var entry = createAnEntry(name, value);
  entryList.push(entry);
}